import React from 'react';
import { ModalNextProvider } from '@jutro/components';

/**
 * Global Modal Queue Manager (Jutro-safe)
 */

const modalQueue = [];
let isModalOpen = false;

const showNextModal = () => {
    if (isModalOpen || modalQueue.length === 0) return;

    isModalOpen = true;

    const { modalElement, originalOnClose } = modalQueue.shift();

    ModalNextProvider.showModal(
        React.cloneElement(modalElement, {
            onClose: () => {
                if (typeof originalOnClose === 'function') {
                    originalOnClose();
                }

                // wait for closing previous modal
                setTimeout(() => {
                    isModalOpen = false;
                    showNextModal();
                }, 0);
            }
        })
    );
};

export default function showQueuedModal(modalElement) {
    modalQueue.push({
        modalElement,
        originalOnClose: modalElement.props?.onClose
    });

    showNextModal();
}

export const clearModalQueue = () => {
    modalQueue.length = 0;
    isModalOpen = false;
};
